module.exports = __webpack_public_path__ + "static/media/email2.235c211b.svg";